module.exports = __webpack_public_path__ + "assets/profile_primary.9dd13bcf.svg";